import { Directive, HostListener, input, output } from '@angular/core';

export type NavigationAction =
  | 'navigate-down'
  | 'navigate-up'
  | 'select-focused'
  | 'close-overlay';

@Directive({
  selector: '[appAutocompleteKeyboardNavigation]',
  standalone: true,
})
export class AutocompleteKeyboardNavigationDirective {
  isOverlayOpen = input<boolean>(false, {
    alias: 'appAutocompleteKeyboardNavigation',
  });
  navigationAction = output<NavigationAction>();

  @HostListener('keydown', ['$event'])
  handleKeyDown(event: KeyboardEvent): void {
    // Only handle keyboard events when overlay is open
    if (!this.isOverlayOpen()) {
      return;
    }

    switch (event.key) {
      // Horizontal arrows - let input handle naturally (cursor movement)
      case 'ArrowLeft':
      case 'ArrowRight':
        // Don't preventDefault - allow natural cursor movement in input
        break;

      // Vertical arrows - navigate options list
      case 'ArrowDown':
        event.preventDefault(); // Prevent cursor from jumping to end of input
        this.navigationAction.emit('navigate-down');
        break;

      case 'ArrowUp':
        event.preventDefault(); // Prevent cursor from jumping to start of input
        this.navigationAction.emit('navigate-up');
        break;

      // Enter - select focused option
      case 'Enter':
        event.preventDefault();
        this.navigationAction.emit('select-focused');
        break;

      // Escape - close overlay
      case 'Escape':
        event.preventDefault();
        this.navigationAction.emit('close-overlay');
        break;
    }
  }
}
